import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const LegalDocument = ({ type: propType }) => {
  const { type: routeType } = useParams(); // 'terms', 'privacy', or 'refund'
  const effectiveType = propType || routeType;
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDocument = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Replace with your actual API base URL
        const apiBaseUrl = process.env.REACT_APP_API_URL || 'https://yoospeak.app:5000';
        const response = await fetch(`${apiBaseUrl}/legal/${effectiveType}`);
        
        if (!response.ok) {
          throw new Error(`Failed to fetch ${effectiveType} document`);
        }
        
        const result = await response.json();
        
        if (result.status === 200 && result.data) {
          setDocument(result.data);
        } else {
          throw new Error(result.message || 'Document not found');
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching legal document:', err);
      } finally {
        setLoading(false);
      }
    };

    if (effectiveType) {
      fetchDocument();
    }
  }, [effectiveType]);

  if (loading) {
    return (
      <div className="legal-document-page py-4">
        <div className="container-xl">
          <div className="text-center">
            <div className="spinner-border text-theme1" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Loading document...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="legal-document-page py-4">
        <div className="container-xl">
          <div className="alert alert-danger" role="alert">
            <h4 className="alert-heading">Error Loading Document</h4>
            <p>{error}</p>
            <hr />
            <p className="mb-0">
              Please try again later or contact support if the problem persists.
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (!document) {
    return (
      <div className="legal-document-page py-4">
        <div className="container-xl">
          <div className="alert alert-primary" role="alert">
            <h4 className="alert-heading">Document Not Found</h4>
            <p>The requested document could not be found.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="legal-document-page py-4">
      <div className="container-xl">
        <div className="heading-wrapper text-center mx-auto mb-4" style={{ maxWidth: '600px' }}>
          <div className="section-heading">{document.title}</div>
        </div>

        <div className="content-wrapper">
          <div className="wrapper mb-4">
            <div className="text-theme1">
              <i className="bi bi-clock"></i> 
              Last Updated: {new Date(document.updatedAt).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </div>
          </div>

          <div className="document-content bg-theme1 border rounded-4 px-3 px-md-4 py-4">
            <div 
              className="legal-content"
              dangerouslySetInnerHTML={{ __html: document.content }}
              style={{
                lineHeight: '1.6',
                fontSize: '16px'
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalDocument;
